import { plainTextFromHtml } from "pages/AppraisalManagment/utils/myPafHelpers";

/** Normalize appraisal progress workflow status to a snake_case key. */
export const normalizeAppraisalProgressStatusKey = (record) => {
  const raw =
    record?.status ??
    record?.appraisal_status ??
    record?.workflow_status ??
    record?.display_status ??
    "";

  let statusText = "";
  if (raw !== undefined && raw !== null && raw !== "") {
    if (typeof raw === "string") {
      statusText = raw;
    } else if (typeof raw === "number") {
      statusText = String(raw);
    } else if (typeof raw === "object") {
      statusText = raw?.name || raw?.label || "";
    }
  }

  return String(statusText).trim().toLowerCase().replace(/\s+/g, "_");
};

/** True when manager/OM returned the PAF to the supervisor for revision. */
export const isAppraisalReturnedToSupervisor = (record) => {
  const key = normalizeAppraisalProgressStatusKey(record);
  return (
    key === "returned_to_supervisor" ||
    key === "returned" ||
    (key.includes("returned") && key.includes("supervisor"))
  );
};

/** Manager rejection remarks from API (`manager_rejection_remarks`). */
export const getManagerRejectionRemarksFromRecord = (record) => {
  return plainTextFromHtml(record?.manager_rejection_remarks);
};

/** @deprecated Use getManagerRejectionRemarksFromRecord */
export const getManagerRejectionCommentsFromRecord = (record) =>
  getManagerRejectionRemarksFromRecord(record);
